import { MenuItem } from 'carbon-react/esm/components/menu';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

type MenuItemWithReactRouterProps = React.ComponentProps<typeof MenuItem> & {
  to: string;
};

const MenuItemWithReactRouter: React.FC<MenuItemWithReactRouterProps> = ({
  to,
  onClick,
  ...props
}) => {
  const navigate = useNavigate();

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLButtonElement>) => {
      if (onClick) {
        onClick(event);
      }
      if (!event.defaultPrevented) {
        event.preventDefault();
        void navigate(to);
      }
    },
    [to, navigate, onClick],
  );

  return <MenuItem {...props} onClick={handleClick} href={to} />;
};

export default MenuItemWithReactRouter;
